import { StringKey } from '../../../../lang/index';

export enum ApproveTargetBasedColumn {
  APPROVAL_DATE = 'approval-date',
  GRANT = 'grant',
  ISSUED_SHARES = 'issued-shares',
  PLAN_NAME = 'plan-name',
  PLAN_TYPE = 'plan-type',
  SELECT = 'select',
  SHARE_CLASS = 'share-class',
  STAKEHOLDER = 'stakeholder',
  TARGET_DATE = 'target-date',
  TARGET_NAME = 'target-name',
  VESTED_PERCENTAGE = 'vested-percentage',
  VESTING_WEIGHT = 'vesting-weight',
}

export const approveTargetBasedColumnTitle: Record<ApproveTargetBasedColumn, StringKey> = {
  [ApproveTargetBasedColumn.SELECT]: 'EMPTY',
  [ApproveTargetBasedColumn.STAKEHOLDER]: 'STAKEHOLDER',
  [ApproveTargetBasedColumn.GRANT]: 'GRANT',
  [ApproveTargetBasedColumn.PLAN_TYPE]: 'PLAN_TYPE',
  [ApproveTargetBasedColumn.PLAN_NAME]: 'PLAN_NAME',
  [ApproveTargetBasedColumn.SHARE_CLASS]: 'SHARE_CLASS',
  [ApproveTargetBasedColumn.TARGET_NAME]: 'TARGET_NAME',
  [ApproveTargetBasedColumn.VESTING_WEIGHT]: 'VESTING_WEIGHT',
  [ApproveTargetBasedColumn.VESTED_PERCENTAGE]: 'VESTED_PERCENTAGE',
  [ApproveTargetBasedColumn.TARGET_DATE]: 'TARGET_DATE',
  [ApproveTargetBasedColumn.APPROVAL_DATE]: 'APPROVAL_DATE',
  [ApproveTargetBasedColumn.ISSUED_SHARES]: 'ISSUED_SHARES',
};

export const approveTargetBasedColumnMap = Object.keys(approveTargetBasedColumnTitle);
